function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as cardCouponApi from '@/api/cardCouponApi';
import * as empTagApi from '@/api/empTagApi';
import { Debounce } from '@/utils/validate';
import throttle from '@/utils/throttle';
export default {
  name: 'CardCouponDialog',
  props: {
    companyList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    parkingLotList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    fucardList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      visible: false,
      loading: false,
      pram: {},
      companyOptions: [],
      companySearchLoading: false,
      parkingLotOptions: [],
      parkingLotSearchLoading: false,
      fucardOptions: [],
      fucardSearchLoading: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    // 创建节流后的搜索函数 - 标签搜索（使用人群）
    this.throttledCompanySearch = throttle(function () {
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      console.log('执行了', keyword);
      _this.companySearchLoading = true;
      var reqkeyword = keyword[0];
      empTagApi.getTagAutocomplete(reqkeyword).then(function (res) {
        console.log('res', res);
        // 处理返回数据，将 {tagId, tagName} 格式转换为组件需要的格式
        // const data = res.data || []
        _this.companyOptions = res;
        _this.companySearchLoading = false;
      }).catch(function () {
        _this.companySearchLoading = false;
      });
    }, 300);

    // 创建节流后的搜索函数 - 停车场搜索
    this.throttledParkingLotSearch = throttle(function () {
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      _this.parkingLotSearchLoading = true;
      var reqkeyword = keyword[0];
      cardCouponApi.getParkingLotList(reqkeyword).then(function (res) {
        var data = res || [];
        _this.parkingLotOptions = data.map(function (item) {
          return {
            value: item.parkCode,
            label: item.parkName,
            code: item.parkCode
          };
        });
        _this.parkingLotSearchLoading = false;
      }).catch(function () {
        _this.parkingLotSearchLoading = false;
      });
    }, 300);

    // 创建节流后的搜索函数 - 福卡搜索
    this.throttledFucardSearch = throttle(function () {
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      console.log('throttledFucardSearch', keyword);
      _this.fucardSearchLoading = true;
      var reqkeyword = keyword[0];
      cardCouponApi.getFucardList(reqkeyword).then(function (res) {
        _this.fucardOptions = res || [];
        _this.fucardSearchLoading = false;
      }).catch(function () {
        _this.fucardSearchLoading = false;
      });
    }, 300);
  },
  methods: {
    loadCompanyList: function loadCompanyList() {
      var _this2 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      // 直接加载，不使用节流（用于初始化）
      this.companySearchLoading = true;
      empTagApi.getTagAutocomplete(keyword).then(function (res) {
        // 处理返回数据，将 {tagId, tagName} 格式转换为组件需要的格式
        var data = res.data || [];
        _this2.companyOptions = data;
        _this2.companySearchLoading = false;
      }).catch(function () {
        _this2.companySearchLoading = false;
        _this2.$message.error('获取标签列表失败');
      });
    },
    loadFucardList: function loadFucardList() {
      var _this3 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      // 直接加载福卡列表，不使用节流（用于初始化）
      this.fucardSearchLoading = true;
      cardCouponApi.getFucardList(keyword).then(function (res) {
        _this3.fucardOptions = res || [];
        _this3.fucardSearchLoading = false;
      }).catch(function () {
        _this3.fucardSearchLoading = false;
        _this3.$message.error('获取福卡列表失败');
      });
    },
    loadParkingLotList: function loadParkingLotList() {
      var _this4 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      // 直接加载停车场列表，不使用节流（用于初始化）
      this.parkingLotSearchLoading = true;
      cardCouponApi.getParkingLotList(keyword).then(function (res) {
        var data = res || [];
        _this4.parkingLotOptions = data.map(function (item) {
          return {
            value: item.parkCode,
            label: item.parkName,
            code: item.parkCode
          };
        });
        _this4.parkingLotSearchLoading = false;
      }).catch(function () {
        _this4.parkingLotSearchLoading = false;
        _this4.$message.error('获取停车场列表失败');
      });
    },
    handleParkingLotSearch: function handleParkingLotSearch(keyword) {
      // 使用节流函数进行停车场搜索
      if (this.throttledParkingLotSearch) {
        this.throttledParkingLotSearch(keyword);
      } else {
        // 如果节流函数还未创建，直接调用
        this.loadParkingLotList(keyword);
      }
    },
    handleCompanySearch: function handleCompanySearch(keyword) {
      // 使用节流函数进行搜索
      console.log('handleCompanySearch', keyword);
      if (this.throttledCompanySearch) {
        this.throttledCompanySearch(keyword);
      } else {
        // 如果节流函数还未创建，直接调用
        this.loadCompanyList(keyword);
      }
    },
    handleFucardSearch: function handleFucardSearch(keyword) {
      // 使用节流函数进行福卡搜索
      console.log('handleFucardSearch', keyword);
      if (this.throttledFucardSearch) {
        this.throttledFucardSearch(keyword);
      } else {
        // 如果节流函数还未创建，直接调用
        this.loadFucardList(keyword);
      }
    },
    open: function open() {
      var _this5 = this;
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // 使用传入的 props 数据
      // 初始化使用人群选项（标签列表）
      this.companyOptions = _toConsumableArray(this.companyList);
      this.parkingLotOptions = (this.parkingLotList || []).map(function (item) {
        return {
          value: item.parkCode,
          label: item.parkName,
          code: item.parkCode
        };
      });
      this.fucardOptions = _toConsumableArray(this.fucardList);

      // 处理 userGroupIds：如果是字符串，转换为数组
      var userGroupIds = [];
      if (data.userGroupIds) {
        if (typeof data.userGroupIds === 'string') {
          // 如果是逗号分隔的字符串，转换为数组
          userGroupIds = data.userGroupIds.split(',').map(function (id) {
            var numId = Number(id.trim());
            return isNaN(numId) ? id.trim() : numId;
          }).filter(function (id) {
            return id !== '' && id !== null && id !== undefined;
          });
        } else if (Array.isArray(data.userGroupIds)) {
          // 如果已经是数组，直接使用
          userGroupIds = data.userGroupIds.map(function (id) {
            var numId = Number(id);
            return isNaN(numId) ? id : numId;
          });
        }
      }

      // 处理停车场编码
      var parkingLotCodes = data.parkingLotCodes ? data.parkingLotCodes.split(',').map(function (code) {
        return code.trim();
      }).filter(function (code) {
        return code;
      }) : [];
      var parkingLotValues = parkingLotCodes.map(function (code) {
        var item = _this5.parkingLotOptions.find(function (opt) {
          return opt.code === code;
        });
        return item ? item.value : null;
      }).filter(function (val) {
        return val !== null;
      });
      if (data.id) {
        // 编辑模式：将接口返回的数据映射到表单字段
        this.pram = {
          id: data.id,
          productName: data.productName || '',
          productAmount: data.productAmount || '',
          targetAudience: userGroupIds,
          unionMemberUse: data.isUnionMember !== undefined ? data.isUnionMember : 0,
          returnFudou: data.returnFudou || '',
          returnFudouId: data.returnFudouId || '',
          inventory: data.inventory || '',
          validityType: data.validityType === 2 ? 'date' : 'days',
          validityDays: data.validityDays || '',
          validityDate: data.startDate && data.endDate ? [data.startDate, data.endDate] : null,
          parkingLot: parkingLotValues,
          status: data.status !== undefined ? data.status : 1,
          remark: data.cardRemark || ''
        };
      } else if (data.productName || Object.keys(data).length > 0) {
        // 复制模式：有数据传入但没有id，回显数据但不设置id
        this.pram = {
          productName: data.productName || '',
          productAmount: data.productAmount || '',
          targetAudience: userGroupIds,
          unionMemberUse: data.isUnionMember !== undefined ? data.isUnionMember : 0,
          returnFudou: data.returnFudou || '',
          returnFudouId: data.returnFudouId || '',
          inventory: data.inventory || '',
          validityType: data.validityType === 2 ? 'date' : 'days',
          validityDays: data.validityDays || '',
          validityDate: data.startDate && data.endDate ? [data.startDate, data.endDate] : null,
          parkingLot: parkingLotValues,
          status: data.status !== undefined ? data.status : 1,
          remark: data.cardRemark || ''
        };
      } else {
        // 新增模式：初始化默认值
        this.pram = {
          productName: '',
          productAmount: '',
          targetAudience: [],
          unionMemberUse: 0,
          returnFudou: '',
          returnFudouId: '',
          inventory: '',
          validityType: 'days',
          validityDays: '',
          validityDate: null,
          parkingLot: [],
          status: 1,
          remark: ''
        };
      }
      this.visible = true;
      this.$nextTick(function () {
        if (_this5.$refs.pram) {
          _this5.$refs.pram.clearValidate();
        }
      });
    },
    handleValidityTypeChange: function handleValidityTypeChange() {
      if (this.pram.validityType === 'days') {
        this.pram.validityDate = null;
      } else {
        this.pram.validityDays = '';
      }
    },
    handleSubmit: Debounce(function () {
      var _this6 = this;
      this.$refs.pram.validate(function (valid) {
        if (!valid) return;
        _this6.loading = true;

        // 转换数据格式以符合接口要求
        var params = {
          productName: _this6.pram.productName,
          productAmount: Number(_this6.pram.productAmount),
          returnFudou: Number(_this6.pram.returnFudou),
          inventory: Number(_this6.pram.inventory),
          isUnionMember: Number(_this6.pram.unionMemberUse),
          status: Number(_this6.pram.status),
          cardRemark: _this6.pram.remark || '',
          validityType: _this6.pram.validityType === 'days' ? 1 : 2
        };

        // 福卡选择处理
        if (_this6.pram.returnFudouId) {
          params.returnFudouId = _this6.pram.returnFudouId;
        }

        // 编辑时需要传递 id
        if (_this6.pram.id) {
          params.id = _this6.pram.id;
        }

        // 有效期处理
        if (_this6.pram.validityType === 'days') {
          // 购买后几日有效
          params.validityDays = Number(_this6.pram.validityDays);
        } else if (_this6.pram.validityType === 'date' && _this6.pram.validityDate && _this6.pram.validityDate.length === 2) {
          // 指定有效期
          params.startDate = _this6.pram.validityDate[0];
          params.endDate = _this6.pram.validityDate[1];
        }

        // 停车场处理
        if (_this6.pram.parkingLot && _this6.pram.parkingLot.length > 0) {
          var selectedParkingLots = _this6.pram.parkingLot.map(function (value) {
            return _this6.parkingLotOptions.find(function (item) {
              return item.value === value;
            });
          }).filter(function (item) {
            return item;
          });
          var parkingLotNames = selectedParkingLots.map(function (item) {
            return item.label;
          });
          params.parkingLotCodes = _this6.pram.parkingLot;
          params.parkingLotNames = parkingLotNames;
        }

        // 使用人群处理 (userGroupIds 是公司ID列表)
        if (_this6.pram.targetAudience && _this6.pram.targetAudience.length > 0) {
          params.userGroupIds = _this6.pram.targetAudience;
        }
        var api = params.id ? cardCouponApi.updateCardCoupon : cardCouponApi.addCardCoupon;
        api(params).then(function () {
          _this6.$message.success('操作成功');
          _this6.loading = false;
          _this6.visible = false;
          _this6.$emit('refresh');
        }).catch(function () {
          _this6.loading = false;
        });
      });
    }),
    closeDialog: function closeDialog() {
      this.visible = false;
    }
  }
};